import React, { memo } from 'react';

import { useWindowSize } from '@wwe-portal/ui/hooks/use-window-size';
import { formatThousands } from '@wwe-portal/utils/format';
import { renderWrestlerGemImage } from '../../utils/superstar-details/helper';
import CircledIcon from './CircledIcon';
import { cn } from '../../../../../packages/ui/lib/lib';

interface WrestlerGemProps {
  icon: string;
  score: number;
}

const WrestlerGem: React.FC<WrestlerGemProps> = ({ icon, score }) => {
  /**
   * Use window size custom hook
   */
  const { width } = useWindowSize();

  const mob = width < 768;

  return (
    <div
      className={cn('text-center', {
        'flex basis-1/3 flex-col items-center': mob,
      })}
    >
      <CircledIcon icon={renderWrestlerGemImage(icon) ?? ''} />
      <span className="text-inlineTextColor6 text-xs">
        {formatThousands(score)}
      </span>
    </div>
  );
};

export default memo(WrestlerGem);
